import React, { type InputHTMLAttributes } from "react";

import classNames from "classnames";

import { ReactComponent as CheckboxCheck } from "../../assets/icons/CheckboxCheck.svg";
import { ReactComponent as CheckboxDash } from "../../assets/icons/CheckboxDash.svg";

import style from "./Checkbox.module.css";

interface CheckboxProps {
  indeterminate?: boolean;
}

export const Checkbox = React.forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & CheckboxProps
>(({ indeterminate, className, ...attrs }, ref) => {
  return (
    <label
      className={classNames(style.checkboxWrapper, className, attrs.disabled && style.disabled)}
    >
      <input type="checkbox" {...attrs} ref={ref} />
      {indeterminate && (
        <div className={classNames(style.checkmark, style.indeterminate)}>
          <CheckboxDash />
        </div>
      )}
      {!indeterminate && (
        <div className={classNames(style.checkmark)}>
          <CheckboxCheck />
        </div>
      )}
    </label>
  );
});

Checkbox.displayName = "Checkbox";
